var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tank-name",domProps:{"textContent":_vm._s(_vm.name.replace(/\s+/g, '\n'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }